import { useParams } from 'react-router-dom'

export default function useTransportationBasePath() {
  const { dealerId } = useParams()
  return dealerId ? `/dealers/${dealerId}/transportation` : '/transportation'
}
